



































import { Component, Vue } from "vue-property-decorator";
import { copyDesignButtonStyle } from "@/services/styles/designButtonStylesService";
import { CopyStyle } from "@/services/styles/types";

@Component
export default class DesignButtonStyleCopyModal extends Vue {
    model = {} as CopyStyle;
    name = "";

    open(id: string, name: string) {
        this.model.id = id;
        this.model.name = name + " Copy";
        this.name = name;
        this.$bvModal.show("modal-designButtonStyleCopy");
    }

    confirm() {
        this.$bvModal.hide("modal-designButtonStyleCopy");
        copyDesignButtonStyle(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyStyle;
    }

    decline() {
        this.$bvModal.hide("modal-designButtonStyleCopy");
    }
}
